function wiredata() {
    var sheet = document.createElement('style'),
        $rangeInput = jQuery('.range input'),
        prefs = ['webkit-slider-runnable-track', 'moz-range-track', 'ms-track'];

    document.body.appendChild(sheet);

    var getTrackStyle = function (el) {
        var curVal = el.value;

        // Set active label
        jQuery('.range-labels li, .wireprofile').removeClass('active selected');

        var curLabel = jQuery('.range-labels').find('li:nth-child(' + curVal + ')');
        var curDatabox = jQuery('#wireprofile-' + curVal);

        curLabel.addClass('active selected');
        curDatabox.addClass('active selected');
        $('.range').removeClass('js-label-hide-left');
        $('.range').removeClass('js-label-hide-right');
        if (curLabel.position().left < 130 && curVal != $rangeInput.attr('min')) {
            $('.range').addClass('js-label-hide-left');
        }
        if ($('.tx-pxc-wiredata').width() - curLabel.position().left < 130 && curVal != $rangeInput.attr('max')) {
            $('.range').addClass('js-label-hide-right');
        }
    }

    $rangeInput.on('input', function () {
        sheet.textContent = getTrackStyle(this);
    });
    $rangeInput.trigger('input');

    // Change input value on label click
    jQuery('.range-labels li').on('click', function () {
        var index = jQuery(this).index();

        $rangeInput.val(index + 1).trigger('input');
    });

    $('.range-textinput input').on('keyup', function (e) {
        var val = parseFloat($(this).val().replace(',', '.'));
        $(this).closest('.tx-pxc-wiredata').find('.range-labels li').each(function (el) {
            if (parseFloat($(this).find('span').data('label')) <= val && (parseFloat($(this).next().find('span').data('label')) > val || $(this).next().length < 1)) {
                $(this).trigger('click');
            }
        });
    });

    $('.range-next').on('click', function () {
        $rangeInput.val(parseInt($rangeInput.val()) + 1);
        $rangeInput.trigger('input');
    });
    $('.range-prev').on('click', function () {
        $rangeInput.val(parseInt($rangeInput.val()) - 1);
        $rangeInput.trigger('input');
    });
}

jQuery(document).ready(function () {
    wiredata();
});
